"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WheelFrame;
require("core-js/modules/web.dom-collections.iterator.js");
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _react = require("react");
var _fi = require("react-icons/fi");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function WheelFrame(_ref) {
  let {
    Carusel,
    posterItems,
    onFrontPosterChange,
    isExecuting,
    isStatic
  } = _ref;
  const [upArrow, setUpArrow] = (0, _react.useState)(0);
  const [downArrow, setDownArrow] = (0, _react.useState)(0);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.frameContainer,
    children: [!isStatic && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.upArrow,
      onClick: () => setUpArrow(upArrow + 1),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fi.FiChevronUp, {
        size: 40
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.innerSquare,
      style: {
        boxShadow: isExecuting ? "inset 0px 0px 10px 5px black" : 'none'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Carusel, {
        onUpArrow: upArrow,
        onDownArrow: downArrow,
        posterItems: posterItems,
        onFrontPosterChange: onFrontPosterChange,
        isStatic: isStatic
      })
    }), !isStatic && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.downArrow,
      onClick: () => setDownArrow(downArrow + 1),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fi.FiChevronDown, {
        size: 40
      })
    })]
  });
}